import React from 'react'

/**
 * @typedef {Object} ButtonProps
 * @property {string} [className]
 * @property {'default'|'destructive'|'outline'|'secondary'|'ghost'|'link'} [variant]
 * @property {'default'|'sm'|'lg'|'icon'} [size]
 */

/** @type {React.ForwardRefExoticComponent<ButtonProps & React.ButtonHTMLAttributes<HTMLButtonElement> & React.RefAttributes<HTMLButtonElement>>} */
const Button = React.forwardRef(
  ({ className = '', variant = 'default', size = 'default', ...props }, ref) => {
    const classes = [
      'btn',
      `btn--${variant}`,
      size !== 'default' ? `btn--${size}` : '',
      className,
    ]
      .filter(Boolean)
      .join(' ')

    return <button className={classes} ref={ref} {...props} />
  }
)

Button.displayName = 'Button'

export default Button
